import { axios } from '@/services/axios';

export const updateCountry = (countryData) => {
    return axios.put('/country', countryData);
};
